// Generated by ReScript, PLEASE EDIT WITH CARE


function getSizeOfValue(value) {
  var element = document.createElement("div");
  var style = element.style;
  style.position = "absolute";
  style.top = "-9999px";
  style.left = "-9999px";
  style.width = value;
  var body = document.body;
  body.appendChild(element);
  var size = element.getBoundingClientRect().width;
  body.removeChild(element);
  return size;
}

function getSpacingSize() {
  return getSizeOfValue("var(--spacing)");
}

function getRemSize() {
  return getSizeOfValue("1rem");
}

export {
  getSizeOfValue ,
  getSpacingSize ,
  getRemSize ,
}
/* No side effect */
